module.exports = __webpack_public_path__ + "static/media/logo.4fe417d8.svg";